import { useMutation } from '@tanstack/react-query'
import { forgotPassword } from '../utils/forgotPassword'
import type { ApiError } from '@/types/api'
import { toast } from '@/integrations/toaster-provider'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useForgotPasswordMutation = (onSuccess?: VoidFunction) => {
  return useMutation({
    mutationFn: (email: string) => forgotPassword(email),
    onSuccess: () => {
      toast.success('Password reset instructions sent to your email')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'Failed to send password reset email')
    },
  })
}
